<template>
  <span :class="{ 'is-unknown': isUnknown }">
    {{ formattedValue }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'unknown',
  },
});

const formattedValue = computed(() => {
  if (isUnknown.value) {
    return props.placeholder;
  }

  return props.value;
});

const isUnknown = computed(() => !props.value || props.value.trim().length === 0);
</script>

<style scoped lang="scss">
.is-unknown {
  opacity: 0.7;
}
</style>
